import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import CreateTicketingCommentMutation from '../../../../../mutations/ticketing/tickets/createTicketingCommentMutation';

export interface CreateCommentInput {
	bodyMd: string;
	mentions: string[];
}

export function useCreateComment() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(ticketId: string, input: CreateCommentInput) {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				CreateTicketingCommentMutation,
				{ticketId, bodyMd: input.bodyMd},
				response => {
					setLoading(false);
					resolve(response.createTicketingComment.comment);
				},
				err => {
					setLoading(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
